export default "__VITE_ASSET__4b3b564c__"